import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex items-center justify-center py-20 bg-primary-dark">
      <div className="text-center">
        <div className="loading-spinner mx-auto mb-4"></div>
        <p className="text-gray-400 text-sm">Yükleniyor...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
